import React from 'react';
import Table from 'react-bootstrap/Table';

import IUtils from './IUtils';

class NetworkHeader extends React.Component {
  render() {
    let labels = {totalStakedLabel: "Total Staked", percentStakedLabel: "Percent Staked", circulatingSupplyLabel: "Circulating Supply",
        delegates: "Delegates", totalSupplyLabel: "Total Supply", latestBlockLabel: "Synced Till", currentEpoch: "Epoch",
        currentRewardRate: "In Consensus ARR", eligibleARR: "Top 100 Min ARR", weightedStake: "Total Weighted Stake"};
    let labelsSmall = {totalStakedLabel: "Staked", percentStakedLabel: "% Staked", circulatingSupplyLabel: "Circulating",
        delegates: "Delegates", totalSupplyLabel: "Total Supply", latestBlockLabel: "Synced Till", currentEpoch: "Epoch",
        currentRewardRate: "ARR", eligibleARR: "Top 100 Min ARR", weightedStake: "Weighted Stake"};

    if (window.innerWidth < 600) {
      labels = labelsSmall;
    }

    // <td>{labels.currentRewardRate}</td>
    // <th>{this.props.coinStat.currentRewardRate}</th>
    // <td>{labels.eligibleARR}</td>
    // <th>{this.props.coinStat.otherArr}</th>

    return (
      <React.Fragment>
        <Table bordered hover variant="dark" size="sm" >
          <tbody>
            <tr>
              <td>{labels.totalStakedLabel}</td>
              <th>{IUtils.formatBigCoinCount(this.props.coinStat.totalStake)}</th>
              <td>{labels.percentStakedLabel}</td>
              <th>{this.props.coinStat.percentStaked}%</th>
            </tr>
            <tr>
              <td>{labels.weightedStake}</td>
              <th>{IUtils.formatBigCoinCount(this.props.coinStat.totalWeightedStake)}</th>
              <td>{labels.delegates}</td>
              <th>{this.props.coinStat.stakingPools}</th>
            </tr>

            <tr>
              <td>{labels.circulatingSupplyLabel}</td>
              <th>{IUtils.formatBigCoinCount(this.props.coinStat.circulatingSupply)}</th>
              <td>{labels.latestBlockLabel}</td>
              <th>{this.props.coinStat.recentBlock}</th>
            </tr>

            <tr>
              <td>{labels.totalSupplyLabel}</td>
              <th>{IUtils.formatBigCoinCount(this.props.coinStat.totalSupply)}</th>
              <td>{labels.currentEpoch}</td>
              <th>{this.props.coinStat.currentEpoch}</th>
            </tr>
          </tbody>
        </Table>
      </React.Fragment>
    );
  }
}

export default NetworkHeader;



// WEBPACK FOOTER //
// ./src/iotex/NetworkHeader.js